import type { ComponentPropsWithoutRef, ReactElement } from 'react';
import { ExternalLink } from '@/components/links/external-link';
import pimConfig from '@/configs/pim-config';

type PimLinkProps = Omit<
  ComponentPropsWithoutRef<typeof ExternalLink>,
  'href'
> & {
  href: string;
  withIcon?: boolean;
  iconSize?: number;
};

export function PimLink({
  href,
  withIcon = true,
  iconSize = 3,
  ...props
}: PimLinkProps): ReactElement {
  return (
    <ExternalLink
      href={`${pimConfig.url}${href}`}
      iconSize={iconSize}
      withIcon={withIcon}
      {...props}
    />
  );
}
